import React from 'react';
import { object, string } from 'prop-types';
import { getTagAttributes, getTagText, sanitize } from '../../helpers/compilerHelper';
import { isMarkedText, isTerm } from '../../utils/richTextUtils';
import useCompiler, { DEFAULT_OPTIONS } from '../../hooks/useCompiler';
import { KovMarkedText, KovTerm } from '../contentBlock';

const Compiler = ({ text = '', options = DEFAULT_OPTIONS }) => {
  const { filterHTML, term, markedText, sanitizeOptions } = useCompiler(options);

  const html = sanitize(text, {
    filterHTML,
    compileMarkedText: markedText?.compile,
    compileTerm: term?.compile,
    sanitizeConfig: sanitizeOptions,
  });

  const MarkedTextComponent = markedText?.component ?? KovMarkedText;
  const TermComponent = term?.component ?? KovTerm;

  return (
    <>
      {html.map((section, i) => {
        if (isMarkedText(section)) {
          return (
            <MarkedTextComponent
              key={i}
              text={getTagText(section)}
              {...getTagAttributes(section)}
              compilerOptions={options}
              modes={markedText?.modes}
              onClick={markedText?.onClick}
              onHover={markedText?.onHover}
            />
          );
        }
        if (isTerm(section)) {
          return (
            <TermComponent
              key={i}
              text={getTagText(section)}
              {...getTagAttributes(section)}
              highlight={term?.highlight}
              onClick={term?.onClick}
            />
          );
        }
        return (
          <span key={i} className="compiled-text" dangerouslySetInnerHTML={{ __html: section }} />
        );
      })}
    </>
  );
};

Compiler.propTypes = {
  text: string,
  options: object,
};

export default Compiler;
